<template>
<div class="container-fluid pg-login">
    <div class="otif-webui">
        <div class="otif-container otif-form-container otif-login-form-container">

            <form name="infofusion-dashboard" id="login-form-dashboard" action="/login" method="POST" @submit.prevent="onSubmit">
                 <fieldset>
                     <div class="legend-container">
                         <legend></legend>
                     </div>

                     <div class="login-subinfo">
                         <div class="login-version pull-right">
                             Version 16.4
                         </div>
                     </div>

                     <div class="otif-form-input-container">
                         <div id="login-error" class="otif-alert-container" v-show="error">{{ errorMessage }}</div>

                        <div class="OTformgroupsingle">
                            <label>Username:</label>
                            <input type="text" class="OTcontrol" name="username" id="input-username" v-model="username"/>
                            <div class="otif-clearfix"></div>
                        </div>

                        <div class="OTformgroupsingle">
                            <label>Password:</label>
                            <input type="password"  class="OTcontrol" name="password" id="input-password" v-model="password"/>
                            <div class="otif-clearfix"></div>
                        </div>

                        <div class="login-btn-action">
                            <button type="submit" name="submit" value="Login" id="login-button" class="OTbuttonPrimary">
                                Sign in
                            </button>
                            <div class="otif-clearfix"></div>
                        </div>

                        <div class="login-footer">
                            <div class="login-version pull-right">
                                Copyright &copy; 2018 Open Text. All rights reserved
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
</div>
</template>
<script>

import ManualControls from './debugging/ManualControls.vue';

import axios from 'axios';

export default {
    data() {
        return {
            username: '',
            password: '',
            error: false,
            errorMessage: null,
        }
    },

    methods: {
        onSubmit() {
            axios.post('/otif-dashboard-api/api/v1/authenticate/login', {
                username: this.username,
                password: this.password
            })
            .then((res) => {
                this.username = null;
                this.password = null;
                this.$emit('loggedIn');
            })
            .catch((err) => {
                this.error = true;
                this.errorMessage = 'There was an error trying to log in. Please verify your username and password and try again.';
            });
        }
    },

    computed: {
        debug() {
            return process.env.NODE_ENV === 'development';
        }
    },
    components: {
        ManualControls
    }
}

</script>

